import React from 'react';
import { RootStack } from 'src/navigation/RootNavigation';
import withScreenErrorBoundary from 'src/navigation/withScreenErrorBoundary';
import BlockedUsersScreen from './screens/BlockedUsers';
import EditProfileScreen from './screens/EditProfile';
import ReputationScreen from './screens/Reputation';
const Reputation = withScreenErrorBoundary(ReputationScreen);
const EditProfile = withScreenErrorBoundary(EditProfileScreen);
const BlockedUsers = withScreenErrorBoundary(BlockedUsersScreen);
export const renderUserStackRoutes = ({}) => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "User_Reputation", component: Reputation }),
        React.createElement(RootStack.Screen, { name: "User_EditProfile", component: EditProfile }),
        React.createElement(RootStack.Screen, { name: "User_BlockedUsers", component: BlockedUsers })));
};
